export enum EntityType {
  REGION = 'REGION',
  BASIN = 'BASIN',
  STATE = 'STATE',
  COUNTY = 'COUNTY',
  ASSET = 'ASSET',
  PIPELINE = 'PIPELINE',
}
